
import Vue from 'vue'
import {
    MessageBox,
    Message,
    Loading,
    // Notification,
    // Tag,
    // Switch,
    // ColorPicker,
    // Pagination,
    // Dialog,
    // Autocomplete,
    // Dropdown,
    // DropdownMenu,
    // DropdownItem,
    // Menu,
    // Submenu,
    // MenuItem,
    // MenuItemGroup,
    Input,
    InputNumber,
    // Radio,
    // RadioGroup,
    // RadioButton,
    // Checkbox,
    // CheckboxButton,
    // CheckboxGroup,
    // Select,
    // Option,
    // OptionGroup,
    Button,
    // ButtonGroup,
    // Table,
    // TableColumn,
    // DatePicker,
    Form,
    FormItem,
    // Row,
    // Col,
    // Upload,
    // Cascader,
    // Container,
    // Header,
    // Aside,
    // Main,
    // Icon,
    // Tooltip,
    // Breadcrumb,
    // BreadcrumbItem,
    // Footer,
    // Tree,
    // Transfer,
    // Progress,
    // Card,
    // Tabs,
    // TabPane,
    // Drawer,
    // Popover,
    // Badge,
    Alert,
    // Image,
    // Timeline,
    // TimelineItem
} from 'element-ui'
let LoadingDirective = Loading.directive
const components = {
    LoadingDirective,
    // Tag,
    // Switch,
    // ColorPicker,
    // Pagination,
    // Dialog,
    // Autocomplete,
    // Dropdown,
    // DropdownMenu,
    // DropdownItem,
    // Menu,
    // Submenu,
    // MenuItem,
    // MenuItemGroup,
    Input,
    InputNumber,
    // Radio,
    // RadioGroup,
    // RadioButton,
    // Checkbox,
    // CheckboxButton,
    // CheckboxGroup,
    // Select,
    // Option,
    // OptionGroup,
    Button,
    // ButtonGroup,
    // Table,
    // TableColumn,
    // DatePicker,
    Form,
    FormItem,
    // Row,
    // Col,
    // Upload,
    // Cascader,
    // Container,
    // Header,
    // Aside,
    // Main,
    // Icon,
    // Tooltip,
    // Breadcrumb,
    // BreadcrumbItem,
    // Footer,
    // Tree,
    // Transfer,
    // Progress,
    // Card,
    // Tabs,
    // TabPane,
    // Drawer,
    // Popover,
    // Badge,
    Alert,
    // Image,
    // Timeline,
    // TimelineItem
}

const elementConfig = {
    install(Vue) {
        Object.keys(components).forEach(key => Vue.use(components[key]))
    }
}
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.config.productionTip = false
export default elementConfig